module.exports = __webpack_public_path__ + "img/logo-light.75f7e6c7.png";